import * as types from './types'

export const mutations = {
	[types.ADD_PLAN] (state, plan) {
		state.plans.push(plan)
	},
	[types.REPLACE_PLAN] (state, plan) {
		state.plans = state.plans.map((op) => {
			if (op.id !== plan.id) {
				return op
			} else {
				return plan
			}
		})
	},
	[types.CLEAR_PLANS] (state) {
		state.plans = []
	}
}



// WEBPACK FOOTER //
// ./src/common/store/Plans/mutations.js